(function () {
  if (customElements.get('set-cart-line')) return;

  class SetCartLine extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[data-set-sets]');
      try {
        this.lines = JSON.parse(this.getAttribute('data-set-lines') || '[]');
      } catch (e) {
        this.lines = [];
      }
      this.busy = false;
      this.addEventListener('change', this.onChange.bind(this));
      this.querySelectorAll('[data-set-remove]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.update(0);
        });
      });
      this.querySelectorAll('[data-set-fix]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.update(parseInt(el.getAttribute('data-set-fix')) || 0);
        });
      });
    }

    onChange(event) {
      if (!this.input || event.target !== this.input) return;
      event.stopPropagation();
      let sets = parseInt(this.input.value);
      if (isNaN(sets) || sets < 0) sets = 0;
      const max = parseInt(this.input.getAttribute('max'));
      if (!isNaN(max) && sets > max) {
        sets = max;
        this.input.value = String(max);
      }
      this.update(sets);
    }

    update(sets) {
      if (this.busy || !this.lines.length) return;
      this.busy = true;

      const updates = {};
      this.lines.forEach((line) => {
        updates[line.key] = sets * line.qty;
      });

      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

      const cartItems = this.closest('cart-items');
      if (cartItems) cartItems.classList.add('pointer-events-none');
      this.setAttribute('aria-busy', 'true');
      const loader = this.querySelector('[data-set-loader]');
      if (loader) loader.hidden = false;

      fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), body: JSON.stringify({ updates, sections: sections.join(',') }) })
        .then((response) => response.json())
        .then((parsed) => {
          if (parsed.status) {
            this.fail(parsed.description || parsed.message || (theme.cartStrings && theme.cartStrings.error) || 'Sepet güncellenemedi');
            return;
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsed });
        })
        .catch(() => {
          this.fail((theme.cartStrings && theme.cartStrings.error) || 'Sepet güncellenemedi');
        })
        .finally(() => {
          this.busy = false;
        });
    }

    fail(message) {
      const cartItems = this.closest('cart-items');
      if (cartItems) cartItems.classList.remove('pointer-events-none');
      this.removeAttribute('aria-busy');
      const loader = this.querySelector('[data-set-loader]');
      if (loader) loader.hidden = true;
      if (this.input) this.input.value = this.input.defaultValue;
      const node = this.querySelector('[data-set-error]');
      if (node) {
        node.textContent = message;
        node.hidden = false;
      }
    }
  }

  customElements.define('set-cart-line', SetCartLine);
})();
